export class Page {
  public index: number;
  public pageContainer: PIXI.Container;
  public headText: PIXI.Text;
  public body: any; //can be anything from image to a container containing  diffrents stuffs;
  private styleHeadText: PIXI.TextStyle;
  private styleBodyText: PIXI.TextStyle;
  private images:Array<PIXI.Sprite>;
  private imagesScaleDefault:Array<number>;
  private imagesScalePortrait:Array<number>;
  private smallPcDisplay:boolean
  constructor(
    pageNumber: number,
    headText: string,
    body: any,
    parent: PIXI.Container,
    smallPcDisplay:boolean
  ) {
    // console.log(pageNumber, headText, body, parent)
    this.smallPcDisplay=smallPcDisplay;
    this.smallPcDisplay
    this.index = pageNumber;
    this.images=[];
    this.pageContainer = new PIXI.Container();
    // console.log(parent)
    parent.addChild(this.pageContainer);
    this.styleHeadText = new PIXI.TextStyle({
      fontFamily: "Tahoma, Helvetica, sans-serif",
      fontSize: 50,
      fill: "#ffffff",
      // fontWeight: "bold",
      lineHeight: 55,
      align: "center",
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      wordWrap: true,
      wordWrapWidth: 1200,
    });
    this.styleBodyText = new PIXI.TextStyle({
      fontFamily: "Tahoma, Helvetica, sans-serif",
      fontSize: 25,
      fill: "#ffffff",
      // fontWeight: "bold",
      lineHeight: 35,
      align: "center",
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      wordWrap: true,
      wordWrapWidth: 1350,
    });
    this.headText = new PIXI.Text(headText, this.styleHeadText);
    if (typeof body == "string") {
      this.body = new PIXI.Text(body, this.styleBodyText);
    } else {
      this.body = body;
    }
    
    this.pageContainer.addChild(this.headText);
    this.pageContainer.addChild(this.body);
    this.headText.anchor.set(.5)
    this.headText.x = 1920 / 2 //- this.headText.width / 2;
    this.headText.y = 125;
    if(this.smallPcDisplay==false)
    {
      this.headText.y=120
    }

    if(this.body.text!=undefined)
    {
        this.body.anchor.set(.5,0);
        this.body.x = 1920 / 2 ;
    }
    else
    {
      this.body.x = 1920 / 2 - this.body.width / 2;
    }
   
    this.body.y = 200;

    this.imagesScaleDefault=[];
    this.imagesScalePortrait=[];
    // console.log(pageNumber,':',this.pageContainer.height,this.headText.text)
  }
  public setTitelColor=(newColor:number):void=>
  {
      
     this.headText.style.fill=newColor;
          
      
  }
  public setImage(
    imageSprite: PIXI.Sprite,
    pos: Array<number>,
    defaultScale: number,portraitScale:number ,anchorY:number=0
  ) {
 
    

  
    let index=this.images.length;
    this.images[index]= imageSprite;
    this.images[index].anchor.set(0.5,anchorY);

    this.images[index].position.set(pos[0], this.pageContainer.height+pos[1])//offset);
    this.pageContainer.addChild(this.images[index]);
    
  
   
    this.images[index].scale.set(defaultScale);
 
   
    this.imagesScaleDefault[index]=defaultScale;
    this.imagesScalePortrait[index]=portraitScale;
    // console.log( this.pageContainer.height+pos[1])
  }

  public setTextSizePortrait = (bool: boolean) => {
      // console.log(typeof(this.body.text))
    let scale = 1;
    if (bool) {
      scale = 1.7;     
    }

    if (this.body.text!=undefined) {
      this.body.style.fontSize = 25*scale;
      this.body.style.lineHeight=35*scale;
      // console.log('newSize')
    }

    
    this.headText.style.fontSize = 55*(scale*.75);

    for (let i = 0; i < this.images.length; i++) {

      if(this.body.height!=undefined)
      {
        this.images[i].y=this.body.y+this.body.height;
        
        if(bool)
        {
          this.images[i].scale.set(this.imagesScalePortrait[i]);
          // console.log(this.imagesScalePortrait)
        }
        else
        {
          this.images[i].scale.set(this.imagesScaleDefault[i]);
        }
      }
      else
      {
        this.images[i].y=200;
      }

    }


  
    
  };


  public setBodyElemScale=(newScale:number):void=>
  {
    this.body.scale.set(newScale);
    this.body.x= 1920/ 2 - this.body.width / 2;

      if(this.body instanceof PIXI.Text)
      {
        this.body.style.wordWrapWidth=newScale==1?1100:1300;
      }

  }
}
